import {Buffer} from 'buffer';

import {toMongo} from '../../util/filters';

function parseBase64TypedId(
  encodedId: string | null | undefined,
  expectedType: string
): string | null {
  if (!encodedId) {
    return null;
  }
  try {
    const decoded = Buffer.from(encodedId, 'base64').toString();
    const match = decoded.match(new RegExp(`^${expectedType}:(\\d+)$`));
    return match ? match[1] : null;
  } catch {
    return null;
  }
}

export function createProjectIdFilter(
  internalProjectId: string
): string | undefined {
  const projectId = parseBase64TypedId(internalProjectId, 'ProjectInternalId');

  if (!projectId) {
    return undefined;
  }

  return JSON.stringify(
    toMongo({
      op: '=',
      key: {
        section: 'run',
        name: 'project_id',
      },
      value: projectId,
    })
  );
}

export function createArtifactCollectionIdsFilter(
  artifactCollectionIds: string[]
): string | undefined {
  const parsedIds = artifactCollectionIds
    .map(id => parseBase64TypedId(id, 'ArtifactCollection'))
    .filter((id): id is string => id !== null);

  if (parsedIds.length === 0) {
    return undefined;
  }

  return JSON.stringify(
    toMongo({
      key: {section: 'artifact', name: 'id'},
      op: 'IN',
      value: parsedIds,
    })
  );
}

export const createUserIdFilter = (userId: string): string | undefined => {
  const parsedUserId = parseBase64TypedId(userId, 'User');
  if (!parsedUserId) {
    return undefined;
  }
  return JSON.stringify(
    toMongo({
      key: {section: 'run', name: 'user_id'},
      op: '=',
      value: parsedUserId,
    })
  );
};
